'use client';

import { CustomImage } from 'components/shared/custom-image';
import styles from './WhyItMatters.module.css';

/**
 * The reason-list icon, as its own client island.
 *
 * `next/image` is a Client Component and `CustomImage` hands it a `loader`
 * function, which cannot cross a server→client boundary (it throws at runtime,
 * and the build does not catch it — see
 * docs/app-router-migration/02-rendering-and-data-fetching.md). Isolating the
 * image here is what lets WhyItMatters itself stay a Server Component.
 */
const ReasonIcon = ({ src }: { src: string }) => (
  <CustomImage
    src={src}
    alt=""
    aria-hidden="true"
    width={24}
    height={24}
    className={styles.icon}
  />
);

export default ReasonIcon;
